import {OnInit, OnDestroy, Directive} from "@angular/core";
import {SubscriptionBase} from "./SubscriptionBase";


@Directive()
export class ComponentBase extends SubscriptionBase implements OnInit, OnDestroy {



    public ngOnInit(): void {
        console.log(`Init component ${this.componentName}  ${this.uuid}`);
    }

    public ngOnDestroy(): void {
        console.log(`Destroy component ${this.componentName}  ${this.uuid}`);
        console.log(`unsubscribing ${this.subscriptions.length} listeners`);
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }
}
